export const ADVANCED_TECHNOLOGY_PAGE = "/pages/advanced-technology/";
export const CUSTOM_DESIGN_PAGE = "/pages/custom-design/";
export const SUSTAINABILITY_PAGE = "/pages/sustainability/";
export const CUTTING_COSTS_PAGE = "/pages/cutting-costs/";
export const ABOUT_US_PAGE = "/pages/about-us/";
export const PRIVACY_POLICY_PAGE = "/privacy-policy/";
